var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 6.61523V20.4619C18.9998 21.7309 17.9614 22.7695 16.6924 22.7695H7.46191C6.19281 22.7695 5.1545 21.731 5.1543 20.4619V6.61523H19ZM14.9619 2L16.1152 3.1543H20.1543V5.46191H4V3.1543H8.03809L9.19238 2H14.9619Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteLesson);
export default __webpack_public_path__ + "static/media/delete-lesson.138854ec0dd2045e4b687b74e8bb28e0.svg";
export { ForwardRef as ReactComponent };